module.exports = __webpack_public_path__ + "assets/compass-edab8ac36373820c36f0ba02bb4d6849.svg";